<template>
  <div>
    <template>
      <v-container fluid>
        <v-row>
          <v-col cols="12">
            <Subheader icon="mdi-card-text" title="Allgemein"></Subheader>
            <div class="mt-4">
              <v-card>
                <v-card-text>
                  <v-container fluid>
                    <v-row>
                      <v-col cols="12" sm="3">
                        <v-text-field
                          v-model.number="performanceTargetLocal.sortKey"
                          type="number"
                          clearable
                          label="Sortierschlüssel"
                          :rules="[rules.required]"
                          outlined
                        ></v-text-field
                      ></v-col>
                      <v-col cols="12" sm="3">
                        <v-text-field
                          v-model.trim="performanceTargetLocal.shortTitle"
                          :counter="6"
                          clearable
                          label="Kurzbezeichnung"
                          :rules="[rules.required]"
                          outlined
                        ></v-text-field
                      ></v-col>
                      <v-col cols="12" sm="6">
                        <v-text-field
                          v-model.trim="performanceTargetLocal.title"
                          :counter="32"
                          label="Bezeichnung"
                          required
                          :rules="[rules.required]"
                          outlined
                        ></v-text-field>
                      </v-col>
                    </v-row>
                  </v-container>
                </v-card-text>
              </v-card>
            </div>
          </v-col>
          <v-col cols="12">
            <Subheader icon="mdi-cog" title="Einstellungen"></Subheader>
            <div class="mt-4">
              <v-card>
                <v-card-text>
                  <v-container fluid>
                    <v-row>
                      <v-col cols="12" sm="6">
                        <v-switch
                          v-model="performanceTargetLocal.isActive"
                          dense
                          inset
                          label="Aktive Zielvorgabe"
                          class="mt-0"
                        ></v-switch>
                      </v-col>
                    </v-row>
                    <v-row>Verwendung zulässig ab:</v-row>
                    <v-row>
                      <v-col cols="12" sm="6" md="4">
                        <v-text-field
                          v-model="performanceTargetLocal.validFrom.date"
                          type="date"
                          label="Startdatum"
                          hint="DD.MM.YYYY"
                          outlined
                          :rules="[rules.required, rules.startBeforeEnd]"
                          required
                          prepend-inner-icon="mdi-calendar-start"
                        ></v-text-field>
                      </v-col>
                      <v-col cols="12" sm="6" md="3">
                        <v-text-field
                          v-model="performanceTargetLocal.validFrom.time"
                          label="Startzeit"
                          hint="HH:MM"
                          :rules="[rules.required, rules.startBeforeEnd]"
                          outlined
                          type="time"
                          prepend-inner-icon="mdi-clock-start"
                        ></v-text-field>
                      </v-col>
                    </v-row>
                    <v-row>Verwendung zulässig bis:</v-row>
                    <v-row>
                      <v-col cols="12" sm="6" md="4">
                        <v-text-field
                          v-model="performanceTargetLocal.validUntil.date"
                          type="date"
                          label="Enddatum"
                          hint="DD.MM.YYYY"
                          outlined
                          :rules="[rules.required, rules.startBeforeEnd]"
                          required
                          prepend-inner-icon="mdi-calendar-end"
                        ></v-text-field>
                      </v-col>
                      <v-col cols="12" sm="6" md="3">
                        <v-text-field
                          v-model="performanceTargetLocal.validUntil.time"
                          label="Endzeit"
                          hint="HH:MM"
                          outlined
                          :rules="[rules.required, rules.startBeforeEnd]"
                          type="time"
                          prepend-inner-icon="mdi-clock-end"
                        ></v-text-field>
                      </v-col>
                    </v-row>
                    <v-row>Anwendbar auf:</v-row>
                    <v-row>
                      <v-col cols="12" sm="6" md="6">
                        <v-select
                          v-model="performanceTargetLocal.applicableDivisionIds"
                          :items="divisions"
                          label="Abteilung/Einheit"
                          outlined
                          multiple
                          :rules="[rules.required]"
                          item-value="meta.id"
                          item-text="title"
                        ></v-select>
                      </v-col>
                    </v-row>
                    <v-row>Betrachtungszeitraum:</v-row>
                    <v-row>
                      <v-col cols="12" sm="6" md="6">
                        <v-select
                          v-model="
                            performanceTargetLocal.monitoringInterval.unit
                          "
                          :items="monitoringIntervalTypes"
                          label="Typ"
                          outlined
                          :rules="[rules.required]"
                        ></v-select>
                      </v-col>
                      <v-col cols="12" sm="6" md="6">
                        <v-text-field
                          v-model.number="
                            performanceTargetLocal.monitoringInterval.value
                          "
                          type="number"
                          label="Wert"
                          outlined
                          :rules="[rules.required]"
                        ></v-text-field>
                      </v-col>
                    </v-row>
                  </v-container>
                </v-card-text>
              </v-card>
            </div>
          </v-col>
          <v-col cols="12">
            <Subheader
              icon="mdi-traffic-light"
              title="Ampel-Anforderung"
            ></Subheader>
            <div class="mt-4">
              <v-card>
                <v-card-text>
                  Wähle die höchste Ampelstufe, für die diese Zielvorgabe
                  erfüllt sein muss. Die Zielvorgabe gilt dann automatisch auch
                  für alle niedrigeren Stufen (Kaskadierung: Grün → Gelb → Rot).
                </v-card-text>
                <v-card-text>
                  <v-container fluid>
                    <v-row>
                      <v-col cols="12" sm="5">
                        <v-select
                          v-model="performanceTargetLocal.requiredForLevel"
                          :items="trafficLightLevelOptions"
                          item-text="text"
                          item-value="value"
                          label="Erforderlich für Ampelstufe"
                          outlined
                          hide-details="auto"
                          prepend-inner-icon="mdi-traffic-light"
                        >
                          <template v-slot:selection="{ item }">
                            <v-icon small :color="item.color" class="mr-2">
                              mdi-circle
                            </v-icon>
                            {{ item.text }}
                          </template>
                          <template v-slot:item="{ item }">
                            <div class="d-flex flex-column">
                              <div class="d-flex align-center">
                                <v-icon small :color="item.color" class="mr-2"
                                  >mdi-circle</v-icon
                                >
                                <span>{{ item.text }}</span>
                              </div>
                              <div class="ml-6 text-caption grey--text">
                                {{ item.description }}
                              </div>
                            </div>
                          </template>
                        </v-select>
                      </v-col>

                      <v-col>
                        <v-card outlined>
                          <v-card-text>
                            <div class="text-caption grey--text mb-2">
                              Vorschau: Diese Zielvorgabe beeinflusst folgende
                              Ampelstufen
                            </div>
                            <div class="d-flex align-center">
                              <!-- Green Light -->
                              <v-tooltip bottom>
                                <template v-slot:activator="{ on, attrs }">
                                  <div
                                    class="d-flex flex-column align-center mr-4"
                                    v-bind="attrs"
                                    v-on="on"
                                  >
                                    <v-icon
                                      :color="
                                        performanceTargetLocal.requiredForLevel ===
                                        'green'
                                          ? 'success'
                                          : 'grey lighten-2'
                                      "
                                      :size="
                                        performanceTargetLocal.requiredForLevel ===
                                        'green'
                                          ? 40
                                          : 32
                                      "
                                    >
                                      {{
                                        performanceTargetLocal.requiredForLevel ===
                                        "green"
                                          ? "mdi-circle"
                                          : "mdi-circle-outline"
                                      }}
                                    </v-icon>
                                    <span
                                      class="text-caption mt-1"
                                      :class="
                                        performanceTargetLocal.requiredForLevel ===
                                        'green'
                                          ? 'font-weight-bold success--text'
                                          : 'grey--text'
                                      "
                                    >
                                      Grün
                                    </span>
                                  </div>
                                </template>
                                <span>
                                  {{
                                    performanceTargetLocal.requiredForLevel ===
                                    "green"
                                      ? "Diese Zielvorgabe MUSS für Grün erfüllt sein"
                                      : "Diese Zielvorgabe ist NICHT erforderlich für Grün"
                                  }}
                                </span>
                              </v-tooltip>

                              <!-- Yellow Light -->
                              <v-tooltip bottom>
                                <template v-slot:activator="{ on, attrs }">
                                  <div
                                    class="d-flex flex-column align-center mr-4"
                                    v-bind="attrs"
                                    v-on="on"
                                  >
                                    <v-icon
                                      :color="
                                        performanceTargetLocal.requiredForLevel ===
                                          'green' ||
                                        performanceTargetLocal.requiredForLevel ===
                                          'yellow'
                                          ? 'orange'
                                          : 'grey lighten-2'
                                      "
                                      :size="
                                        performanceTargetLocal.requiredForLevel ===
                                          'green' ||
                                        performanceTargetLocal.requiredForLevel ===
                                          'yellow'
                                          ? 40
                                          : 32
                                      "
                                    >
                                      {{
                                        performanceTargetLocal.requiredForLevel ===
                                          "green" ||
                                        performanceTargetLocal.requiredForLevel ===
                                          "yellow"
                                          ? "mdi-circle"
                                          : "mdi-circle-outline"
                                      }}
                                    </v-icon>
                                    <span
                                      class="text-caption mt-1"
                                      :class="
                                        performanceTargetLocal.requiredForLevel ===
                                          'green' ||
                                        performanceTargetLocal.requiredForLevel ===
                                          'yellow'
                                          ? 'font-weight-bold orange--text'
                                          : 'grey--text'
                                      "
                                    >
                                      Gelb
                                    </span>
                                  </div>
                                </template>
                                <span>
                                  {{
                                    performanceTargetLocal.requiredForLevel ===
                                      "green" ||
                                    performanceTargetLocal.requiredForLevel ===
                                      "yellow"
                                      ? "Diese Zielvorgabe MUSS für Gelb erfüllt sein"
                                      : "Diese Zielvorgabe ist NICHT erforderlich für Gelb"
                                  }}
                                </span>
                              </v-tooltip>

                              <!-- Red Light -->
                              <v-tooltip bottom>
                                <template v-slot:activator="{ on, attrs }">
                                  <div
                                    class="d-flex flex-column align-center mr-4"
                                    v-bind="attrs"
                                    v-on="on"
                                  >
                                    <v-icon
                                      :color="
                                        performanceTargetLocal.requiredForLevel ===
                                          'green' ||
                                        performanceTargetLocal.requiredForLevel ===
                                          'yellow' ||
                                        performanceTargetLocal.requiredForLevel ===
                                          'red'
                                          ? 'error'
                                          : 'grey lighten-2'
                                      "
                                      :size="
                                        performanceTargetLocal.requiredForLevel ===
                                          'green' ||
                                        performanceTargetLocal.requiredForLevel ===
                                          'yellow' ||
                                        performanceTargetLocal.requiredForLevel ===
                                          'red'
                                          ? 40
                                          : 32
                                      "
                                    >
                                      {{
                                        performanceTargetLocal.requiredForLevel ===
                                          "green" ||
                                        performanceTargetLocal.requiredForLevel ===
                                          "yellow" ||
                                        performanceTargetLocal.requiredForLevel ===
                                          "red"
                                          ? "mdi-circle"
                                          : "mdi-circle-outline"
                                      }}
                                    </v-icon>
                                    <span
                                      class="text-caption mt-1"
                                      :class="
                                        performanceTargetLocal.requiredForLevel ===
                                          'green' ||
                                        performanceTargetLocal.requiredForLevel ===
                                          'yellow' ||
                                        performanceTargetLocal.requiredForLevel ===
                                          'red'
                                          ? 'font-weight-bold error--text'
                                          : 'grey--text'
                                      "
                                    >
                                      Rot
                                    </span>
                                  </div>
                                </template>
                                <span>
                                  {{
                                    performanceTargetLocal.requiredForLevel ===
                                      "green" ||
                                    performanceTargetLocal.requiredForLevel ===
                                      "yellow" ||
                                    performanceTargetLocal.requiredForLevel ===
                                      "red"
                                      ? "Diese Zielvorgabe MUSS für Rot erfüllt sein"
                                      : "Diese Zielvorgabe ist NICHT erforderlich für Rot"
                                  }}
                                </span>
                              </v-tooltip>

                              <!-- No Requirement Indicator -->
                              <v-tooltip
                                bottom
                                v-if="!performanceTargetLocal.requiredForLevel"
                              >
                                <template v-slot:activator="{ on, attrs }">
                                  <div
                                    class="d-flex flex-column align-center"
                                    v-bind="attrs"
                                    v-on="on"
                                  >
                                    <v-icon color="grey" size="40">
                                      mdi-cancel
                                    </v-icon>
                                    <span
                                      class="text-caption mt-1 grey--text font-weight-bold"
                                    >
                                      Keine
                                    </span>
                                  </div>
                                </template>
                                <span>
                                  Diese Zielvorgabe wird nur verfolgt,
                                  beeinflusst aber keine Ampelstufe
                                </span>
                              </v-tooltip>
                            </div>
                          </v-card-text>
                        </v-card>
                      </v-col>
                      <v-spacer class="hidden-sm-and-down"></v-spacer>
                    </v-row>
                  </v-container>
                </v-card-text>
              </v-card>
            </div>
          </v-col>
          <v-col cols="12">
            <Subheader icon="mdi-variable" title="Variablen"></Subheader>
            <div class="mt-4">
              <v-card>
                <v-card-text
                  >Hinweis: Als Datengrundlage können lediglich Dienstberichte
                  und/oder Stundenmeldungen dienen, die sich im Status "Zu
                  prüfen", "Genehmigt" oder "Festgeschrieben"
                  befinden.</v-card-text
                >
                <v-card-text
                  v-if="performanceTargetLocal.dataVariables.length > 0"
                >
                  <v-container fluid>
                    <v-row
                      v-for="(
                        dataVariable, index
                      ) in performanceTargetLocal.dataVariables"
                      :key="index"
                      dense
                    >
                      <v-col cols="12" sm="2" md="2">
                        <v-text-field
                          v-model="dataVariable.variable.text"
                          dense
                          outlined
                          disabled
                          :hint="'ID:' + dataVariable.variable.id"
                          persistent-hint
                          label="Variable"
                        ></v-text-field>
                      </v-col>
                      <v-col cols="12" sm="3" md="3">
                        <v-select
                          v-model="dataVariable.sourceType"
                          dense
                          label="Datenquelle"
                          small-chips
                          outlined
                          item-key="id"
                          hide-details="auto"
                          :items="variableTypes"
                          return-object
                          @change="updateUnitBasedOnSourceType(dataVariable)"
                          ><template v-slot:item="{ item }">
                            <v-list-item-content>
                              <v-list-item-title class="font-weight-medium">{{
                                item.text
                              }}</v-list-item-title>
                              <v-list-item-subtitle
                                ><span class="font-weight-regular">{{
                                  item.description
                                }}</span></v-list-item-subtitle
                              >
                            </v-list-item-content>
                          </template>
                        </v-select>
                      </v-col>
                      <v-col cols="12" sm="2" md="2">
                        <v-select
                          v-if="
                            dataVariable.sourceType.id ===
                            'sumFromMultipleDataSources'
                          "
                          v-model="dataVariable.unit"
                          :items="unitOptions"
                          item-text="text"
                          item-value="value"
                          dense
                          label="Einheit"
                          outlined
                          hide-details="auto"
                          hint="Manuell wählen"
                          persistent-hint
                        >
                        </v-select>
                        <v-text-field
                          v-else
                          v-model="dataVariable.unit"
                          dense
                          label="Einheit"
                          outlined
                          disabled
                          hide-details="auto"
                          hint="Basiert auf Datenquelle"
                          persistent-hint
                        >
                        </v-text-field
                      ></v-col>
                      <v-col cols="12" sm="4" md="4">
                        <v-select
                          v-model="dataVariable.value"
                          :items="
                            getFilters(
                              dataVariable.sourceType.id,
                              dataVariable.variable.id
                            )
                          "
                          item-key="id"
                          return-object
                          dense
                          label="Filter/Wert"
                          outlined
                          multiple
                          small-chips
                          clearable
                          hide-details="auto"
                        >
                        </v-select
                      ></v-col>

                      <v-btn
                        text
                        depressed
                        class="mt-2"
                        color="error"
                        @click="deleteDataVariable(index)"
                        ><v-icon>mdi-delete</v-icon></v-btn
                      >
                    </v-row>
                  </v-container>
                </v-card-text>
                <v-divider
                  v-if="performanceTargetLocal.dataVariables.length"
                ></v-divider>
                <v-card-actions class="px-4">
                  <v-container fluid>
                    <v-row dense>
                      <v-col cols="4">
                        <v-form
                          ref="newVariableFormRef"
                          v-model="newVariableFormIsValid"
                        >
                          <v-text-field
                            v-model="newVariableName"
                            dense
                            outlined
                            :rules="[rules.required, rules.uniqueVariableName]"
                            label="Bezeichnung für neue Variable vergeben"
                            hide-details="auto"
                          ></v-text-field>
                        </v-form>
                      </v-col>
                      <v-col>
                        <v-btn
                          text
                          small
                          class="ml-2 my-2"
                          @click="addDataVariable"
                          :disabled="!newVariableFormIsValid"
                          ><v-icon left>mdi-plus</v-icon>Variable
                          hinzufügen</v-btn
                        >
                      </v-col>
                    </v-row>
                  </v-container>
                </v-card-actions>
              </v-card>
            </div>
          </v-col>
          <v-col cols="12">
            <Subheader
              icon="mdi-gauge"
              title="IST/SOLL-Vergleich (nur für Anzeige)"
            ></Subheader>
            <div class="mt-4">
              <v-card>
                <v-card-subtitle>
                  Diese Werte dienen nur der visuellen Darstellung in der
                  Benutzeroberfläche. Die tatsächliche Bewertung, ob eine
                  Zielvorgabe erfüllt ist, erfolgt ausschließlich über die
                  Bedingungen im Regeleditor weiter unten.
                </v-card-subtitle>
                <v-card-text>
                  <v-alert dense text type="info" border="left" class="mb-4">
                    <div class="d-flex align-center">
                      <div class="text-caption">
                        <strong>Wichtig:</strong> Der IST-Wert und SOLL-Wert
                        werden nur zur besseren Übersicht in der persönlichen
                        Anzeige und in Berichten dargestellt. Die Erfüllung der
                        Zielvorgabe wird durch die definierten Regeln
                        festgelegt.
                      </div>
                    </div>
                  </v-alert>
                  <v-container fluid>
                    <v-row>
                      <v-col cols="12" sm="6">
                        <v-select
                          v-model="performanceTargetLocal.primaryDataVariable"
                          :items="performanceTargetLocal.dataVariables"
                          label="Primäre Variable (IST-Wert)"
                          outlined
                          clearable
                          persistent-hint
                          hint="Wird als IST-Wert in persönlicher Anzeige und Berichten angezeigt"
                          item-value="variable.id"
                          item-text="variable.text"
                          prepend-inner-icon="mdi-chart-box-outline"
                        >
                          <template v-slot:selection="{ item }">
                            {{ item.variable.text }}
                            <span v-if="item.unit" class="ml-1 grey--text"
                              >({{ item.unit }})</span
                            >
                          </template>
                          <template v-slot:item="{ item }">
                            <v-list-item-content>
                              <v-list-item-title>
                                {{ item.variable.text }}
                              </v-list-item-title>
                              <v-list-item-subtitle v-if="item.sourceType">
                                {{ item.sourceType.text }}
                                <span v-if="item.unit" class="ml-1"
                                  >• {{ item.unit }}</span
                                >
                              </v-list-item-subtitle>
                            </v-list-item-content>
                          </template>
                        </v-select>
                      </v-col>
                      <v-col cols="12" sm="6">
                        <v-text-field
                          v-model.number="
                            performanceTargetLocal.targetValue.value
                          "
                          type="number"
                          label="SOLL-Wert (Referenzwert)"
                          outlined
                          clearable
                          persistent-hint
                          hint="Zielwert für die visuelle Darstellung (hat keinen Einfluss auf die Bewertung)"
                          prepend-inner-icon="mdi-flag-checkered"
                          :suffix="getTargetValueUnit()"
                          @input="syncTargetValueUnit"
                        ></v-text-field>
                      </v-col>
                    </v-row>
                  </v-container>
                </v-card-text>
              </v-card>
            </div>
          </v-col>
          <v-col cols="12">
            <Subheader
              icon="mdi-arrow-decision"
              title="Regeleditor (entscheidet über Zielvorgabe)"
            ></Subheader>
            <div class="mt-4">
              <v-alert
                dense
                type="info"
                colored-border
                border="left"
                class="mb-4"
                elevation="2"
              >
                <div class="d-flex align-center">
                  <div class="text-caption">
                    <strong>Wichtig:</strong> Diese Bedingungen legen fest, ob
                    die Zielvorgabe als "erfüllt" oder "nicht erfüllt" bewertet
                    wird. Dies ist unabhängig vom oben definierten
                    IST/SOLL-Vergleich.
                  </div>
                </div>
              </v-alert>
              <div
                class="caption font-weight-medium primary--text uppercase my-2"
              >
                WENN
              </div>
              <condition-builder
                v-model="performanceTargetLocal.conditions"
                :dataVariables="performanceTargetLocal.dataVariables"
              >
              </condition-builder>
              <div
                class="caption font-weight-medium primary--text uppercase my-2"
              >
                DANN:
              </div>
              <v-card>
                <v-card-title class="d-flex align-center">
                  <data-chip
                    color="green"
                    iconLeft="check-circle"
                    text="Zielvorgabe erfüllt"
                    smallIcon
                  ></data-chip>
                </v-card-title>
              </v-card>

              <div
                class="caption font-weight-medium primary--text uppercase my-2"
              >
                SONST:
              </div>
              <v-card>
                <v-card-title class="d-flex align-center">
                  <data-chip
                    color="red"
                    iconLeft="close-circle"
                    text="Zielvorgabe nicht erfüllt"
                    smallIcon
                  ></data-chip>
                </v-card-title>
              </v-card>
            </div>
          </v-col>
        </v-row>
      </v-container>
    </template>
  </div>
</template>

<script>
import Subheader from "@/components/_systemwide/Subheader.vue";
import ConditionBuilder from "@/components/member-management/performance-targets/ConditionBuilder.vue";
import DataChip from "@/components/_systemwide/DataChip.vue";
import { DUTY_MANAGEMENT, MEMBER_MANAGEMENT } from "@/store/modules.js";
import { GET_REPORT_TYPES, GET_DIVISIONS } from "@/store/action-types.js";
export default {
  name: "performance-target-editor",
  props: {
    performanceTarget: {},
    mode: {
      type: String,
      default: "new",
      required: true,
      validator: function (value) {
        return ["new", "edit"].indexOf(value) !== -1;
      },
    },
  },
  components: {
    Subheader,
    ConditionBuilder,
    DataChip,
  },
  data() {
    return {
      rules: {
        required: (value) => !!value || "Feld ist erforderlich.",
        uniqueVariableName: (value) => {
          if (
            !this.performanceTargetLocal ||
            !this.performanceTargetLocal.dataVariables
          ) {
            return true; // or false, depending on your desired behavior when dataVariables is not defined
          }
          return (
            this.performanceTargetLocal.dataVariables.filter(
              (variable) => variable.variable.text === value
            ).length === 0 || "Bezeichnung bereits vergeben."
          );
        },
      },
      trafficLightLevelOptions: [
        {
          text: "Grün (Höchste Stufe)",
          value: "green",
          color: "success",
          description: "Auch für Gelb & Rot erforderlich",
        },
        {
          text: "Gelb (Mittlere Stufe)",
          value: "yellow",
          color: "orange",
          description: "Auch für Rot erforderlich",
        },
        {
          text: "Rot (Mindeststufe)",
          value: "red",
          color: "error",
          description: "Nur für Rot erforderlich",
        },
        {
          text: "Keine Anforderung",
          value: null,
          color: "grey",
          description: "Wird verfolgt, beeinflusst Ampel nicht",
        },
      ],
      newVariableName: "",
      newVariableFormIsValid: false,
      a: {
        type: "operation",
        leftArgument: {
          type: "variable",
          variableId: "var_id_8c296bf79c9da7afc1a2",
        },
        operation: "==",
        rightArgument: {
          type: "constant",
          value: { type: "ChoiceId", value: "choice_id_7e3eafc19ba46dd72c3d" },
        },
      },
      variableTypes: [
        {
          text: "Summe aus mehreren Datenquellen",
          id: "sumFromMultipleDataSources",
          description: "Summe aus mehreren zuvor (!) definierten Datenquellen",
          unit: null, // Inherits from source variables
        },
        {
          text: "Summe Dienstteilnahme in min",
          id: "totalDutyTimeInMin",
          description: "Berechnet aus Dienstberichten",
          unit: "min",
        },
        {
          text: "Summe Dienstteilnahme in h",
          id: "totalDutyTimeInHours",
          description: "Berechnet aus Dienstberichten",
          unit: "h",
        },
        {
          text: "Summe Dienstteilnahme Anzahl",
          id: "totalDutyTimeCount",
          description: "Berechnet aus Dienstberichten",
          unit: "x",
        },
        {
          text: "Summe Stundenmeldungen in min",
          id: "totalTimeSheetsInMin",
          description: "Berechnet aus Stundenmeldungen",
          unit: "min",
        },
        {
          text: "Summe Stundenmeldungen in h",
          id: "totalTimeSheetsInHours",
          description: "Berechnet aus Stundenmeldungen",
          unit: "h",
        },
        {
          text: "Summe Stundenmeldungen Anzahl",
          id: "totalTimeSheetsCount",
          description: "Berechnet aus Stundenmeldungen",
          unit: "x",
        },
        {
          text: "Summe Funktionsausübung in min",
          id: "totalPositionTimeInMin",
          disabled: true,
          unit: "min",
        },
        {
          text: "Summe Einsatzmittelbesetzung in min",
          id: "totalUnitTimeInMin",
          disabled: true,
          unit: "min",
        },
      ],
      monitoringIntervalTypes: [
        { text: "Vorherige Tage", value: "days" },
        { text: "Laufende Wochen", value: "weeks" },
        { text: "Vorherige Wochen + aktuelle Woche", value: "weeks+current" },
        { text: "Laufende Monate", value: "months" },
        { text: "Vorherige Monate + aktueller Monat", value: "months+current" },
      ],
      unitOptions: [
        { text: "Anzahl (x)", value: "x" },
        { text: "Stunden (h)", value: "h" },
        { text: "Minuten (min)", value: "min" },
      ],
    };
  },
  model: {
    prop: "performanceTarget",
    event: "performanceTargetChange",
  },
  computed: {
    performanceTargetLocal: {
      get: function () {
        return this.performanceTarget;
      },
      set: function (value) {
        this.$emit("performanceTargetChange", value);
      },
    },
    divisions() {
      return this.$store.state.memberManagement.divisions;
    },
    dutyTypes() {
      const dutyType = this.$store.state.dutyManagement.dutyTypes;
      return dutyType.sort((a, b) => a.sortKey - b.sortKey);
    },
  },
  created() {
    this.initialize();
  },
  watch: {
    "performanceTargetLocal.primaryDataVariable": function (newVal) {
      // When primary variable changes, automatically update the target value unit
      if (newVal && this.performanceTargetLocal.targetValue) {
        const unit = this.getTargetValueUnit();
        if (unit && this.performanceTargetLocal.targetValue.unit !== unit) {
          this.performanceTargetLocal.targetValue.unit = unit;
        }
      }
    },
  },
  methods: {
    initialize() {
      this.$store.dispatch(`${MEMBER_MANAGEMENT}${GET_DIVISIONS}`, {
        organizationId: this.$route.params.organizationId,
      });
      this.$store.dispatch(`${DUTY_MANAGEMENT}${GET_REPORT_TYPES}`, {
        organizationId: this.$route.params.organizationId,
      });
    },
    getTargetValueUnit() {
      // Get the unit from the selected primary variable
      if (!this.performanceTargetLocal.primaryDataVariable) {
        return "";
      }
      const primaryVar = this.performanceTargetLocal.dataVariables.find(
        (v) => v.variable.id === this.performanceTargetLocal.primaryDataVariable
      );
      return primaryVar && primaryVar.unit ? primaryVar.unit : "";
    },
    syncTargetValueUnit() {
      // Automatically sync the unit when a value is entered
      if (
        this.performanceTargetLocal.targetValue &&
        this.performanceTargetLocal.targetValue.value !== null
      ) {
        const unit = this.getTargetValueUnit();
        if (unit) {
          this.performanceTargetLocal.targetValue.unit = unit;
        }
      }
    },
    updateUnitBasedOnSourceType(dataVariable) {
      // Auto-set unit based on the selected source type
      if (
        dataVariable.sourceType &&
        dataVariable.sourceType.unit !== undefined
      ) {
        if (dataVariable.sourceType.id === "sumFromMultipleDataSources") {
          // For sum from multiple sources, clear the unit so user can select manually
          dataVariable.unit = null;
        } else {
          // For other sources, auto-assign the unit
          dataVariable.unit = dataVariable.sourceType.unit;
        }
      }
    },
    addDataVariable() {
      const nextDatavariableId =
        "var_id_" + Math.random().toString(36).substr(2, 9);
      this.performanceTargetLocal.dataVariables.push({
        variable: {
          id: nextDatavariableId,
          text: this.newVariableName,
        },
        sourceType: { text: null, id: null },
        value: [],
      });
      this.newVariableName = "";
      this.$refs.newVariableFormRef.resetValidation();
    },
    deleteDataVariable(index) {
      this.performanceTargetLocal.dataVariables.splice(index, 1);
    },
    getFilters(dataVariableTypeId, currentVariableId) {
      switch (dataVariableTypeId) {
        case "sumFromMultipleDataSources":
          return this.performanceTargetLocal.dataVariables
            .map((dataVariable) => {
              return {
                id: dataVariable.variable.id,
                text: dataVariable.variable.text,
              };
            })
            .filter((variable) => variable.id !== currentVariableId);
        case "totalDutyTimeInMin":
        case "totalDutyTimeInHours":
        case "totalDutyTimeCount":
          return this.dutyTypes.map((dutyType) => {
            return {
              id: dutyType.meta.id,
              text: dutyType.title,
            };
          });
        case "totalTimeSheetsInMin":
        case "totalTimeSheetsInHours":
        case "totalTimeSheetsCount":
          return [
            {
              id: "dutyTime",
              text: "Einsatzdienst",
            },
            {
              id: "courseTime",
              text: "Lehrgang/Fortbildung",
            },
            {
              id: "otherTime",
              text: "Sonstige Stunden",
            },
          ];
        default:
          return [];
      }
    },
  },
};
</script>
